/* istanbul ignore file */
import CreateNoteForm from 'domain/people/employee/Timeline/note/form/CreateNoteForm';
import UpdateNoteForm from 'domain/people/employee/Timeline/note/form/UpdateNoteForm';
import EmployeeNoteTimelineRecordLayout from 'domain/people/employee/Timeline/note/shared/layout/EmployeeNoteTimelineRecordLayout';
import { CREATE_EMPLOYEE_NOTE } from 'domain/shared/employee';
import { TimelineRegistry, TimelineItem } from 'domain/people/employee/Timeline/types';

const useEmployeeNoteItem = (): TimelineRegistry => ({
  AddForm: CreateNoteForm,
  UpdateForm: UpdateNoteForm,
  isApplicable: (item: TimelineItem) => !!item.note,
  source: 'note',
  urlPostfix: 'notes',
  RecordLayout: EmployeeNoteTimelineRecordLayout,
  name: 'Note',
  permissionToCheck: CREATE_EMPLOYEE_NOTE,
});

export default useEmployeeNoteItem;
